/**
 * Client-side audience gate for Audio Mode surfaces (the Listen panel and the
 * quiz-builder "Has audio" facet share this so they can never drift).
 *
 * REACT_APP_AUDIO_MODE_AUDIENCE = off|tutors|all, case-insensitive. DELIBERATE
 * divergence from the more-like-this audience parse: there ABSENT = "all" (an
 * already-shipped surface had to stay byte-identical); audio is a NEW surface,
 * so ABSENT — and any unrecognized value — = "off", mirroring the server's
 * fail-closed qlearn.audio.audience parse (QLearn-service AudioModeProperties).
 *
 * UX-only: the server enforces its own audience gate on the manifest/proxy
 * endpoints AND scrubs the hasAudio facet server-side; it stays authoritative.
 */
export const audienceAllows = () => {
  const raw = process.env.REACT_APP_AUDIO_MODE_AUDIENCE;
  if (raw === undefined || raw === null) {
    return false; // absent -> off (fail-closed)
  }
  const value = String(raw).trim().toLowerCase();
  if (value === "all") {
    return true;
  }
  if (value === "tutors") {
    const role = typeof window !== "undefined" ? window.localStorage.getItem("role") : null;
    return role === "ROLE_TUTOR" || role === "ROLE_ADMIN";
  }
  return false; // "off" and anything unrecognized fail closed
};

/** Master flag AND audience — the single mount condition for audio surfaces. */
export const audioModeAvailable = () =>
  process.env.REACT_APP_AUDIO_MODE_ENABLED === "true" && audienceAllows();
